import React, { useState } from 'react';

import Box from '@mui/material/Box';
import startCase from 'lodash/startCase';

import { StyledSubtabs, StyledSubtab } from '../../../../components/StyledSubtabs';
import { DEMAND_APP_ID } from '../../../../store/demand';
import KPIs from '../KPIs';
import KioskUsage from '../../../../components/KioskUsage';

const KPIS = 'kpis';
const KIOSK_USAGE = 'kiosk-usage';
const TABS = [KPIS, KIOSK_USAGE];

export default function Analytics({ tab }) {
  const [selectedTab, setSelectedTab] = useState(KPIS);

  return (
    <Box>
      <StyledSubtabs
        value={selectedTab}
        onChange={(_, v) => setSelectedTab(v)}
        indicatorColor='primary'
        textColor='primary'>
        {TABS.map((t) => (
          <StyledSubtab key={t} label={startCase(t)} value={t} />
        ))}
      </StyledSubtabs>

      {selectedTab === KPIS && <KPIs tab={tab} />}
      {selectedTab === KIOSK_USAGE && <KioskUsage tab={tab} appId={DEMAND_APP_ID} />}
    </Box>
  );
}